<template>
  <div>
    <button class="btn-sm btn-blue m-1" @click="addShowClicked"><span class='text-xl leading-none'>+</span> Add Show</button>

    <b-modal ref="showModal" title="Show" no-close-on-backdrop>
      <form @submit.prevent class="px-8 pt-6 pb-8 mb-4 w-full">
        <vue-form-generator :schema="showSchema" :model="show"/>
        <div class="mt-1 mb-3">
          <h3>Judge</h3>
          <showman-type-ahead v-model="show.judge" class="mt-1" :initialValue="show.judge" @valueChange="setJudge" :placeholder="'Start typing to select or change judge'" :label="'Animal'" :dataEndpoint="'/callFunction/judgeSearch'" :schema="judgeTypeAheadSchema" :internalSearch="false"></showman-type-ahead>
          <p class='mt-1 text-gray-700 text-sm font-medium'>**If you can't find your judge, contact your show specialist to get them added in.</p>
        </div>
        <div class="hr"></div>
        <vue-form-generator :schema="showPricingSchema" :model="show"/>
        <form-generator :form_schema="class_list_schema" :country="event.location_details.country"></form-generator>
        <button class="btn btn-blue" @click="addShowNew">Save Show</button>
        <button class="btn-link" @click="previewClassList">Preview Class List</button>
        <button class="btn-link" @click="previewEntryType">Preview Entry Type</button>

        <v-jsoneditor v-if="classListPreview" v-model="classListPreview" :options="{mode:'text'}" :plus="false" height="800px" class="mt-4"/>
        <v-jsoneditor v-if="entryTypePreview" v-model="entryTypePreview" :options="{mode:'text'}" :plus="false" height="800px" class="mt-4"/>

      </form>
      <div slot="modal-footer" class="w-full">
        <div class="flex justify-end">
          <button class="btn-gray-outline btn-sm" variant="primary" @click="$refs.showModal.hide()">
            Close
          </button>
        </div>
      </div>
    </b-modal>
  </div>

</template>

<script>
import FormGenerator from '@/components/FormGenerator.vue'
import VJsoneditor from 'v-jsoneditor'
import ShowmanTypeAhead from '@/components/ShowmanTypeAhead.vue'

export default {
  props: {
    event: Object
  },
  components: {
    FormGenerator,
    VJsoneditor,
    ShowmanTypeAhead
  },
  data () {
    return {
      show: {},
      classList: {},
      classListPreview: null,
      entryTypePreview: null,
      judgeTypeAheadSchema: {
        idField: 'judge_id',
        searchField1: 'first_name',
        searchField2: 'last_name',
        displayTemplate: '$1 $2 ~ $3',
        displayFields: ['first_name', 'last_name', 'state']
      }
    }
  },
  methods: {
    addShowClicked () {
      this.show = {
        show_settings: {}
      }
      this.classList = {
        division_list: {
          list: [
            {
              name: 'Angus'
            },
            {
              name: 'Charolais'
            },
            {
              name: 'Charolais Composite'
            }
          ],
          entry_field: 'division',
          class_list: 'age_list'
        },
        class_settings: {
          overall_champions: 2,
          division_champions: 2,
          animal_label: ''
        },
        division_classes: {
          'age_list': [
            {
              'end_age': 3,
              'start_age': 0,
              'class_name': 'Junior {{DIVISION}} 0-3 Months',
              'entry_type': 'standard'
            },
            {
              'end_age': 6,
              'start_age': 3,
              'class_name': 'Junior {{DIVISION}} 3-6 Months',
              'entry_type': 'standard'
            },
            {
              'end_age': 9,
              'start_age': 6,
              'class_name': 'Junior {{DIVISION}} 3-6 Months',
              'entry_type': 'standard'
            },
            {
              'end_age': 12,
              'start_age': 9,
              'class_name': 'Junior {{DIVISION}} 3-6 Months',
              'entry_type': 'standard'
            },
            {
              'class_name': 'Champion Junior {{DIVISION}}',
              'entry_type': 'Champion'
            },
            {
              'class_name': 'Reserve Champion Junior {{DIVISION}}',
              'entry_type': 'Champion'
            }
          ]
        }
      }

      this.$refs.showModal.show()
    },
    addShow: function () {
      /* Required
      Show Type
      Show Name
      Show Species
      Class LIst
      Label/Type
      Class List Type
      class Settinubg
      - Animal Label
      */

      // TODO: Need to add show to show list
      // this.show.show_date = parse(this.show.show_date)
      // Make sure pricing Details are set
      if (!this.show.pricing_details) {
        this.show.pricing_details = {
          rate: 0,
          late_rate: 0
        }
      }
      this.$store.dispatch('createNewShow', this.show)
        .then(response => {
          this.$refs.showModal.hide()
          this.notie.alert({
            type: 1,
            text: `Show, ${this.show.name} Successfully Create`
          })
          this.new_show = {
            show_settings: {}
          }
        })
        .catch(() => {
          // this.$honeybadger.notify(error)
          this.notie.alert({
            type: 3,
            text: `Error creating show, please check all fields and try again.<br>You can send an email to <b>${process.env.VUE_APP_SUPPORT_EMAIL}</b> if the error continues.`
          })
        })
    },
    addShowNew: function () {
      this.show.event_id = this.event.event_id
      this.show.admin_id = this.event.admin_id

      this.$store.dispatch('addShow', {class_list: this.classList, show: this.show})
        .then(response => {
          // // console.log(response)
          this.notie.alert({
            type: 1,
            text: `SHow Added`
          })
        })
        .catch(() => {
          // // console.log(error)
          // this.$honeybadger.notify(error)
          this.notie.alert({
            type: 3,
            text: `Error Adding SHow, please check all fields and try again.<br>You can send an email to <b>${process.env.VUE_APP_SUPPORT_EMAIL}</b> if the error continues.`
          })
        })
    },
    previewClassList: function () {
      this.$store.dispatch('previewClassList', this.classList)
        .then(response => {
          this.classListPreview = response
          // // console.log(response)
          this.notie.alert({
            type: 1,
            text: `Class List Successfully Generated`
          })
        })
        .catch(() => {
          // // console.log(error)
          // this.$honeybadger.notify(error)
          this.notie.alert({
            type: 3,
            text: `Error saving Generating Entry type, please check all fields and try again.<br>You can send an email to <b>${process.env.VUE_APP_SUPPORT_EMAIL}</b> if the error continues.`
          })
        })
    },
    previewEntryType: function () {
      this.classList.group_type = this.show.type
      this.$store.dispatch('previewEntryType', this.classList)
        .then(response => {
          this.entryTypePreview = response
          // // console.log(response)
          this.notie.alert({
            type: 1,
            text: `Entry TYpe Successfully Generated`
          })
        })
        .catch(() => {
          // // console.log(error)
          // this.$honeybadger.notify(error)
          this.notie.alert({
            type: 3,
            text: `Error generating Entry Type, please check all fields and try again.<br>You can send an email to <b>${process.env.VUE_APP_SUPPORT_EMAIL}</b> if the error continues.`
          })
        })
    },
    setJudge (judge) {
      this.show.judge = judge
    }
  },
  computed: {
    showPricingSchema () {
      return {
        groups: [
          {
            legend: 'Pricing',
            fields: this.pricingFields
          }
        ]
      }
    },
    pricingFields () {
      let fields = []

      if (this.event.entry_settings.early_bird_date) {
        fields.push({
          type: 'input',
          inputType: 'number',
          label: 'Early Rate',
          model: 'pricing_details.early_rate',
          required: true,
          default: 0
        })
      }

      fields.push({
        type: 'input',
        inputType: 'number',
        label: 'Normal Rate',
        model: 'pricing_details.rate',
        required: true,
        default: 0
      })
      fields.push({
        type: 'input',
        inputType: 'number',
        label: 'Late Rate',
        model: 'pricing_details.late_rate',
        required: true,
        default: 0
      })
      if (this.event.entry_settings.has_member_pricing) {
        fields.push({
          type: 'input',
          inputType: 'number',
          label: 'Member Rate',
          model: 'pricing_details.member_rate',
          required: true,
          default: 0
        })
        fields.push({
          type: 'input',
          inputType: 'number',
          label: 'Member Late Rate',
          model: 'pricing_details.member_late_rate',
          required: true,
          default: 0
        })
      }
      fields.push({
        type: 'checkbox',
        label: 'Has Multi Entry Pricing',
        model: 'pricing_details.multi_entry_pricing'
      })
      if (this.show.pricing_details) {
        if (this.show.pricing_details.multi_entry_pricing) {
          fields.push({
            type: 'input',
            inputType: 'number',
            label: 'Multi Entry Discount: Number of Entries',
            hint: 'How many animals does someone have to enter before the special pricing is applied?',
            model: 'pricing_details.multi_entry_number',
            required: false
          })
          if (this.event.entry_settings.early_bird_date) {
            fields.push({
              type: 'input',
              inputType: 'number',
              label: 'Multi Entry Discount: Early Rate',
              model: 'pricing_details.multi_entry_early_rate',
              required: false
            })
          }
          fields.push({
            type: 'input',
            inputType: 'number',
            label: 'Multi Entry Discount: Normal Rate',
            model: 'pricing_details.multi_entry_rate',
            required: false
          })
          fields.push({
            type: 'input',
            inputType: 'number',
            label: 'Multi Entry Discount: Late Rate',
            model: 'pricing_details.multi_entry_late_rate',
            required: false
          })
        }
      }
      return fields
    },
    showSchema () {
      return {
        groups: [
          {
            legend: 'Show Details',
            fields: [
              {
                type: 'input',
                inputType: 'text',
                label: 'Show Name',
                model: 'name',
                placeholder: 'Show Name',
                hint: 'How do you refer to this show? I.E. Boer Goat Blast Show 1 or Boer Goat Blast JABGA Show',
                required: true
              },
              /* {
                type: 'vueMultiSelect',
                label: 'Judge',
                placeholder: 'Select a Judge',
                model: 'judge',
                required: true,
                values: () => {
                  let judges = this.$store.state.judges
                  return judges
                },
                selectOptions: {
                  multiSelect: false,
                  closeOnSelect: true,
                  searchable: true,
                  key: 'judge_id',
                  label: 'first_name',
                  customLabel: function (j) {
                    return `${j.first_name} ${j.last_name} ~ ${j.state}`
                  }
                }
              }, */
              {
                type: 'vueMultiSelect',
                label: 'Show Type',
                placeholder: 'Select a type',
                model: 'type',
                required: true,
                values: [
                  'BREEDING',
                  'SHOWMANSHIP',
                  'MARKET',
                  'GROUP',
                  'EXHIBIT'
                ],
                selectOptions: {
                  multiSelect: false,
                  closeOnSelect: true,
                  searchable: false
                }
              },
              {
                type: 'vueMultiSelect',
                label: 'Species',
                placeholder: 'Select a species',
                model: 'species',
                required: true,
                values: [
                  'GOATS',
                  'SHEEP',
                  'SWINE',
                  'CATTLE',
                  'DAIRY CATTLE',
                  'DAIRY GOATS',
                  'RABBITS',
                  'POULTRY',
                  'OTHER',
                  'EXHIBITOR'
                ],
                selectOptions: {
                  multiSelect: false,
                  closeOnSelect: true,
                  searchable: false
                }
              },
              {
                type: 'input',
                inputType: 'date',
                label: 'Show Date',
                model: 'show_date',
                required: true,
                format: 'YYYY-MM-DD'
              },
              {
                type: 'input',
                inputType: 'text',
                label: 'Show Start Time',
                model: 'start_time',
                required: true,
                hint: 'If there is no hard start time it is ok to put something like 30 min after 1st show ends.'
              },
              {
                type: 'textArea',
                label: 'Details',
                model: 'show_settings.show_details',
                placeholder: 'Additional show details',
                hint: 'Any Additional Info About Show.',
                required: false
              }
            ]
          }
        ]
      }
    },
    class_list_schema () {
      return [
        {
          label: 'Class List',
          model: this.classList,
          fields: [
            {
              type: 'checkbox',
              label: 'Create show only',
              model: 'show_only'
            },
            {
              type: 'input',
              inputType: 'text',
              label: 'Label/ClassType',
              model: 'classType',
              placeholder: 'Label',
              required: true
            },
            /* {
              type: 'checkbox',
              label: 'Is Public',
              model: 'is_public'
            }, */
            {
              type: 'select',
              label: 'Class List Type',
              model: 'class_list_type',
              placeholder: 'Select a class list type',
              options: [
                {value: 'MANUAL_AGE', label: 'MANUAL_AGE'},
                {value: 'MANUAL_WEIGHT', label: 'MANUAL_WEIGHT'},
                {value: 'AGE_RANGE', label: 'AGE_RANGE'},
                {value: 'AGE_CALC', label: 'AGE_CALC'},
                {value: 'SHOWMANSHIP_AGE_MANUAL', label: 'SHOWMANSHIP_AGE_MANUAL'}
              ]
            },
            {
              type: 'json',
              label: 'Division List',
              model: 'division_list'
            },
            {
              type: 'json',
              label: 'Division Classes',
              model: 'division_classes'
            },
            {
              type: 'json',
              label: 'Class Settings',
              model: 'class_settings'
            }
            /* {
              type: 'json',
              label: 'AOB Settings',
              model: 'aob_settings'
            }, */
            /* {
              type: 'submit',
              onSubmit: this.saveClassList,
              buttonText: 'Save Class List'
            },
            {
              type: 'submit',
              onSubmit: this.generateClassList,
              buttonText: 'Generate Class List'
            } */
          ]
        }
      ]
    }
  }
}
</script>

<style>

</style>
